import { render, staticRenderFns } from "./TheBarcodeIndexingConfig.vue?vue&type=template&id=18be2b77&scoped=true&"
import script from "./TheBarcodeIndexingConfig.vue?vue&type=script&lang=js&"
export * from "./TheBarcodeIndexingConfig.vue?vue&type=script&lang=js&"
import style0 from "./TheBarcodeIndexingConfig.vue?vue&type=style&index=0&id=18be2b77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be2b77",
  null
  
)

export default component.exports